module.exports = __webpack_public_path__ + "img/next-point-arrow.c8b57afb.svg";